import { FilterSelect } from "src/@/components/ui/filter-select";
import { Button } from "src/@/components/ui/button";
import { Clock } from "lucide-react";
import { useDashboardContext } from "../../hooks/use-dashboard-context";
import { useCustomHoursEnabled } from "#navigation/utils";
import { t } from "@lingui/core/macro";
type CustomHourOption = {
    value: string;
    label: string;
};

export const CustomHourPicker = () => {
    const { customHourOffset, setCustomHourOffset } = useDashboardContext();

    const options: CustomHourOption[] = [
        { value: "0", label: "12am to 12am" },
        { value: "1", label: "1am to 1am" },
        { value: "2", label: "2am to 2am" },
        { value: "3", label: "3am to 3am" },
        { value: "4", label: "4am to 4am" },
        { value: "5", label: "5am to 5am" },
        { value: "6", label: "6am to 6am" },
    ];

    const customHoursEnabled = useCustomHoursEnabled();

    if (!customHoursEnabled) {
        return null;
    }

    return (
        <FilterSelect
            selectedValues={new Set([customHourOffset])}
            customButton={
                <Button variant="outline" size="sm" className="flex items-center">
                    <Clock className="mr-2 h-4 w-4" />
                    {options.find((opt) => opt.value === customHourOffset)?.label}
                </Button>
            }
            title={t`Custom Hours`}
            onOptionSelected={(value) => setCustomHourOffset(value)}
            options={options}
        />
    );
};
